<template>
	<div class="mobanBox">
		<div class="mobanBoxTit" ref="fjBox">
			<div
				class="mobanItem supHove3"
				:ref="'zjBox' + index + 1"
				@click="tabsFn(index, item)"
				:class="{ mobanItemActive: flag == index }"
				v-for="(item, index) in mbData"
				:key="index"
			>
				{{ item.template }}
			</div>
		</div>
		<div class="mobanCont" ref="mobanCont" :style="{ '--tabsLeft': tabLeft }">
			<h2>模板说明</h2>
			<p>
				Q=对话，D=独白，每套模板都有共十段材料，前五段材料默认全对话一文一答，即1Q，后五段材料结构略有不同。例{{ mbData[flag]?.template }}结构依次为{{
					$jgZfn(mbData[flag]?.template)
				}}。
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'mobanXz',
	data() {
		return {
			flag: 0,
			tabLeft: ''
		};
	},
	props: ['mbData', 'disFlag'],
	methods: {
		tabsFn(index, item) {
			if (this.disFlag) {
				console.log('不可点击');
				this.$message({
					type: 'warning',
					message: '请取消组卷后，切换模板'
				});
				return;
			}
			this.$emit('tabFn', item);
			const fjBox = this.$refs.fjBox;
			const zjBox = this.$refs['zjBox' + index + 1][0];
			if (fjBox && zjBox) {
				const fjBoxRect = fjBox.getBoundingClientRect();
				const zjBoxRect = zjBox.getBoundingClientRect();
				console.log(zjBoxRect.left - fjBoxRect.left, 9999);
				this.tabLeft = `${zjBoxRect.left - fjBoxRect.left + zjBox.clientWidth / 2 - 12}px`;
				this.flag = index;
			}
		},
		tabFn(index, item) {
			this.$emit('tabFn', item);
			const fjBox = this.$refs.fjBox;
			const zjBox = this.$refs['zjBox' + index + 1][0];
			if (fjBox && zjBox) {
				const fjBoxRect = fjBox.getBoundingClientRect();
				const zjBoxRect = zjBox.getBoundingClientRect();
				console.log(zjBoxRect.left - fjBoxRect.left, 9999);
				this.tabLeft = `${zjBoxRect.left - fjBoxRect.left + zjBox.clientWidth / 2 - 12}px`;
				this.flag = index;
			}
		}
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.mobanBox {
	.mobanCont {
		margin-top: 12px;
		padding: 20px 70px;
		border-radius: 4px;
		background: #fff;
		border: 1px solid #1d7b3a;
		position: relative;
		&::before {
			content: '';
			position: absolute;
			z-index: 1;
			top: -11px;
			left: var(--tabsLeft);
			border-bottom: 12px solid #fff;
			border-left: 12px solid transparent;
			border-right: 12px solid transparent;
		}
		&::after {
			content: '';
			position: absolute;
			top: -12px;
			left: var(--tabsLeft);
			border-bottom: 12px solid #1d7b3a;
			border-left: 12px solid transparent;
			border-right: 12px solid transparent;
		}
		h2 {
			font-size: 18px;
			font-weight: bold;
			color: #000000;
			margin-bottom: 12px;
		}
		p {
			font-size: 14px;
			color: #484745;
			line-height: 2;
		}
	}
	.mobanBoxTit {
		height: 60px;
		background: #ffffff;
		border-radius: 6px;
		overflow-y: scroll;
		white-space: nowrap;
		touch-action: none; /* 防止浏览器默认的滑动行为 */
		padding-left: 19px;
		cursor: pointer;
		display: flex;
		align-items: center;

		/* 自定义滚动条整体样式 */
		&::-webkit-scrollbar {
			width: 0px; /* 设置滚动条的宽度 */
			height: 10px;
		}

		/* 自定义滚动条滑块样式 */
		&::-webkit-scrollbar-thumb {
			background-color: #888; /* 设置滑块的颜色 */
			border-radius: 5px; /* 设置滑块的圆角 */
		}

		/* 自定义滚动条轨道样式 */
		&::-webkit-scrollbar-track {
			background-color: #f0f0f0; /* 设置轨道的颜色 */
		}
	}
	.mobanItem {
		margin-right: 40px;
		font-size: 14px;
		color: #000000;
		float: left;
	}
	.mobanItemActive {
		color: #1d7b3a;
	}
}
</style>
